import React, { useState, useEffect } from "react";
// Chakra imports
import {
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  FormControl,
  FormLabel,
  Switch,
} from "@chakra-ui/react";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";
// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import TablesProjectRow from "components/Tables/TablesProjectRow";
import TablesTableRow from "components/Tables/TablesTableRow";
import { tablesProjectData, tablesTableData } from "variables/general";
import useGetServices from "../../hooks/useGetServices";
import CreateService from "../../modals/CreateService";
import EditService from "../../modals/EditService";
import Pagination from "../../views/Custom/Pagination";
import { MySearchBar } from "views/Custom/MySearchBar";

function Services() {
  const [ keyword, setKeyword ] = useState("");
  const [ showArchived, setShowArchived] = useState(false);
  const [ page, setPage ] = useState(1); 
  const pageLimit = 10;
  let { 
    services, 
    totalServices, 
    setGettingServices, 
    gettingServices, 
    gettingServicesReqSuccess 
  } = useGetServices({ 
    page, 
    limit: pageLimit,
    keyword: keyword, 
    showArchived: showArchived,
  });
  const { isOpen: isOpenCreate, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();
  const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
  const [ toEditService, setToEditService ] = useState(null);

  useEffect(() => {
    reloadPage();
  }, [page, keyword, showArchived]);

  // useEffect(() => {
  //   // console.log(services);
  // }, [services]);

  const reloadPage = () => {
    setGettingServices(true);
  }

  const selectEditItem = (id) => {
    // console.log(id);
    const service = services.find((c) => c.id === id);
    // console.log(service.email);
    setToEditService(service);
    onOpenEdit(true);
  }

  const textColor = useColorModeValue("gray.700", "white");

  // const getTotal = (price, products) => {
  //   let total = parseFloat(price);
  //   for (const p of products) {
  //     total += p.price;
  //   }
  //   return total;
  // }

  return (
    <>
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader p="6px 0px 22px 0px">
          <Flex w="100%"
            flexDirection={{
              sm: "row",
              md: "row",
            }}
            alignItems={{ xl: "center" }}>
            <MySearchBar 
              keyword={keyword}
              setKeyword={setKeyword}
              onReload={reloadPage}
            />
            <Spacer />
            <Box>
            <FormControl display="flex" alignItems="center">
              <Switch 
                  defaultChecked={showArchived}
                  colorScheme="teal" 
                  me="10px" 
                  onChange={(e) => setShowArchived(e.target.checked)}
              />
              <FormLabel
                  mb="0"
                  ms="1"
                  fontWeight="normal"
                  >Toggle Archives
              </FormLabel>
            </FormControl>
            </Box>
            <Box>
              <Button colorScheme="teal" mr="4" onClick={onOpenCreate}>
                Create New
              </Button>
            </Box>
          </Flex>
        </CardHeader>
        <CardBody>
          <Flex direction="column" w="100%">
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" p={2} color="gray.400">
                  <Th p={2} color="gray.400">Icon - Title</Th>
                  <Th p={2} color="gray.400">Description</Th>
                  <Th p={2} color="gray.400">Price</Th>
                  <Th p={2} color="gray.400">Items</Th>
                  <Th p={2} color="gray.400">Public</Th>
                  <Th p={2} color="gray.400">Actions</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {gettingServices ? 
                  <Tr my=".8rem" >
                    <Td minWidth={{ sm: "250px" }} p={2} colSpan={4}>
                      <Progress isIndeterminate />
                    </Td>
                  </Tr>
                  : services.map((service) => {
                    return (
                      <Tr my=".8rem" key={`services-item-${service.id}`}>
                        <Td p={2}>
                          <Flex direction="row" w="100%" align="center">
                            <img src={`data:image/jpeg;base64,${service.cover}`} 
                              width="45" 
                              height="45"
                              margin="4px"
                            ></img>
                            <Text margin="4px"> </Text>
                            <Text margin="4px">{service.title}</Text>
                          </Flex>
                        </Td>
                        <Td  p={2}>
                          <Text maxWidth={300} noOfLines={[1, 2, 3]}>
                            {service.description}
                          </Text>
                        </Td>
                        <Td  p={2}>
                          ₱{Number(service.price).toLocaleString()}
                        </Td>
                        <Td p={2}>
                          <Flex direction="column" w="100%">
                          { service.completeProducts.map((product, index) => {
                              return <Text key={`added-product-${product.id}`}>
                                {product.name}
                              </Text>
                            }) 
                          }
                          </Flex>
                        </Td>
                        <Td  p={2}>
                          {service.isPublic 
                            ? <Text color={'green'}>yes</Text>
                            : <Text color={'red'}>no</Text>}
                        </Td>
                        {/* <Td p={2}>
                          <Flex direction="column" w="100%">
                          { getTotal(service.price, service.completeProducts) }
                          </Flex>
                        </Td> */}
                        <Td  p={2}>
                          <Button p="0px" bg="transparent" onClick={() => selectEditItem(service.id)}>
                            <Flex color={textColor} cursor="pointer" align="center" p="12px">
                              <Icon as={FaPencilAlt} me="4px" />
                              <Text fontSize="xs" fontWeight="semibold">
                                EDIT
                              </Text>
                            </Flex>
                          </Button>
                        </Td>
                      </Tr>
                    );
                  })
                }
              </Tbody>
            </Table>
            <Pagination 
              totalItems={totalServices}
              pageRows={pageLimit}
              currentPage={page}
              onPageChanged={setPage}
            />
          </Flex>
        </CardBody>
      </Card>

    </Flex>
    
   <CreateService 
      isOpen={isOpenCreate}
      onClose={onCloseCreate}
      successCallback={reloadPage}
    />

               
    <EditService 
      isOpen={isOpenEdit}
      onClose={() => {
        setToEditService(null);
        onCloseEdit();
      }}
      successCallback={reloadPage}
      serviceData={toEditService}
    />

    </>
  );
}

export default Services;
